<router-outlet></router-outlet>
<p-toast position="bottom-right" [baseZIndex]="10000" [life]="1500"></p-toast>
